<template>
  <div>
    <el-form ref="formData" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.order_spec_label_orderGoodsSpecNo') || '产品规格编号'
            "
            prop="orderGoodsSpecNo"
          >
            <el-input
              clearable
              readonly
              v-model="formData.orderGoodsSpecNo"
              :placeholder="'请输入规格编号'"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="() => (visible = true)"
              ></el-button>

              ></el-input
            >
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.order_spec_label_qty') || '数量'"
            prop="orderQty"
          >
            <el-input readonly v-model="formData.orderQty"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.order_spec_label_orderGoodsSpecName') || '规格名称'
            "
            prop="identifyGoodsName"
          >
            <el-input readonly v-model="formData.identifyGoodsName"></el-input>
          </el-form-item>
        </el-col>
        
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="'裁剪尺寸'" prop="cuttingSizeDesc">
            <el-input v-model="formData.cuttingSizeDesc" size="small">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'裁片门幅'" prop="cuttingWidth">
            <el-input-number
              controls-position="right"
              size="small"
              style="width: 100%"
              :min="0"
              :step="0.001"
              :precision="3"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.cuttingWidth"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'裁片损耗'" prop="cuttingLoss">
            <el-input-number
              controls-position="right"
              size="small"
              style="width: 100%"
              :min="0"
              :step="0.001"
              :precision="3"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.cuttingLoss"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="'裁片数量'" prop="cuttingQty">
            <el-input-number
              controls-position="right"
              size="small"
              style="width: 100%"
              :min="0"
              :step="1"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.cuttingQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'单耗'" prop="unitQty">
            <el-input-number
              controls-position="right"
              size="small"
              style="width: 100%"
              :min="0"
              :step="0.001"
              :precision="3"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.unitQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item :label="'耗料'" prop="fabricQty">
            <el-input-number
              controls-position="right"
              size="small"
              style="width: 100%"
              :min="0"
              :step="0.01"
              :precision="2"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.fabricQty"
            ></el-input-number>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item :label="'合计耗料'" prop="subQty">
            <el-input readonly size="small" v-model="subQty"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="'备注说明'" prop="cuttingRemark">
            <el-input
              v-model="formData.cuttingRemark"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <ChooseOrderGoodsSpecDialog
      :visible.sync="visible"
      :title="'添加订单产品规格'"
      :orderCode="this.orderCode"
      @confirm="onOrderGoodsConfirm"
      append-to-body
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
import ChooseOrderGoodsSpecDialog from '@/views/factory/components/choose-order-goods-spec/dialog.vue'
import Math from '@/libs/util.math.js'
export default {
  components: { ChooseOrderGoodsSpecDialog },
  mixins: [EditLoading],
  props: {
    orderCode: {
      type: String,
      default: ''
    },
    techCuttingCode: {
      type: String,
      default: ''
    },
    techCuttingDetailCode: {
      type: String,
      default: ''
    },
    techCuttingGoodsCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      formData: {
        orderGoodsSpecNo: '',
        techCuttingGoodsCode: '',
        techCuttingDetailCode: '',
        techCuttingCode: '',
        orderGoodsSpecCode: '',
        identifyGoodsSpecNo: '',
        identifyGoodsName: '',
        orderGoodsCode: '',
        orderQty: '',
        cuttingSizeDesc: '',
        cuttingWidth: '',
        cuttingLoss: '',
        unitQty: '',
        fabricQty: '',
        cuttingQty: '',
        cuttingRemark: ''
      },
      rules: {
        orderGoodsSpecNo: [
          {
            required: true,
            message: '请选择规格',
            trigger: 'change'
          }
        ],
        cuttingSizeDesc: [
          {
            required: true,
            message: '请输入裁剪尺寸',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    this.getDate()
  },
  computed: {
    subQty() {
      if (!this.formData) return 0
      const { unitQty, cuttingQty } = this.formData

      if (!unitQty || !cuttingQty) return 0

      let m = 0,
        s1 = cuttingQty.toString(),
        s2 = unitQty.toString()
      try {
        m += s1.split('.')[1].length
      } catch (e) {
        m += 0
      }
      try {
        m += s2.split('.')[1].length
      } catch (e) {
        m += 0
      }
      return (
        (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
        Math.pow(10, m)
      )
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getDate() {
      if (!this.techCuttingGoodsCode) return
      this.$api
        .techCuttingInfoGoodsDetailApi({
          techCuttingGoodsCode: this.techCuttingGoodsCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        return
      }
      this.formData.orderCode = this.orderCode
      this.formData.techCuttingCode = this.techCuttingCode
      this.formData.techCuttingDetailCode = this.techCuttingDetailCode
      this.loadingOpen()
      this.$api
        .techCuttingInfoGoodsSaveApi({ ...this.formData, subQty: this.subQty })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
    onOrderGoodsConfirm(data) {
      this.formData.orderGoodsSpecNo = data.orderGoodsSpecNo
      this.formData.orderGoodsSpecCode = data.orderGoodsSpecCode
      this.formData.identifyGoodsSpecNo = data.identifyGoodsSpecNo
      this.formData.identifyGoodsName = data.identifyGoodsName
      this.formData.orderGoodsCode = data.orderGoodsCode
      this.formData.orderQty = data.qty
    }
  }
}
</script>
